import Http from '../http'
// 执法APP模块API
export default {
  // 获取app用户列表
  userList(params) {
    return Http.post('/app/list.do', params)
  },
  // 添加用户
  addUser(params) {
    return Http.post('/app/add.do', params)
  },
  // 删除用户
  deleteUser(params) {
    return Http.post('/app/delete.do', params)
  },
  // 获取用户信息
  getUser(params) {
    return Http.post('/app/get.do', params)
  },
  // 更新用户信息
  saveUser(params) {
    return Http.post('/app/save.do', params)
  },
  // APP监管部门管理列表
  appRegulatorList(params) {
    return Http.post('/appRegulator/list.do', params)
  },
  // APP监管部门编辑时获取数据
  appRegulatorGet(params) {
    return Http.post('/appRegulator/get.do', params)
  },
  // APP监管部门编辑更新
  appRegulatorUpdate(params) {
    return Http.post('/appRegulator/update.do', params)
  },
  // 修改密码
  appRegulatorResetPwd(params) {
    return Http.post('/appRegulator/resetPwd.do', params)
  },
  // 添加APP监管部门
  appRegulatorAdd(params) {
    return Http.post('/appRegulator/add.do', params)
  },
  // 删除APP监管部门
  appRegulatorDelete(params) {
    return Http.post('/appRegulator/delete.do', params)
  },
  // 获取APP信息
  getAPP(params) {
    return Http.post('/app/getAPP.do', params)
  },
  // 上传APP版本
  upAPP(params) {
    return Http.post('/app/upAPP.do', params)
  },
  // ----------------二级账号-用户管理 begin -----------------
  // 获取用户管理列表
  getUserList(params) {
    return Http.post('appClients/list.do', params)
  },
  // 保存添加用户
  addUser2(params) {
    return Http.post('appClients/add.do', params)
  },
  // 保存编辑用户
  saveUser2(params) {
    return Http.post('appClients/update.do', params)
  },
  // 删除用户管理
  deleteUser2(params) {
    return Http.post('appClients/delete.do', params)
  },
  // 获取单个用户信息
  getSingleUser(params) {
    return Http.post('appClients/get.do', params)
  },
  // 修改用户密码
  modifyUserPW(params) {
    return Http.post('/appClients/resetPwd.do', params)
  },
  // 获取终端授权
  getDevPermit(params) {
    return Http.post('/appClients/getPermit.do', params)
  },
  // 保存终端授权
  saveDevPermit(params) {
    return Http.post('/appClients/savePermit.do', params)
  },
  // ----------------用户管理 end -----------------
  // ----------------角色管理 begin -----------------
  // 获取角色列表
  getRoleList(params) {
    return Http.post('/appRole/list.do', params)
  },
  // 删除角色
  deleteRoleList(params) {
    return Http.post('/appRole/delete.do', params)
  },
  // 获取单个角色
  getSingleRole(params) {
    return Http.post('/appRole/get.do', params)
  },
  // 获取权限树数据
  getPriviData() {
    return Http.post('/appRole/serverConfig.do')
  },
  // 保存添加角色权限
  saveAddRole(params) {
    return Http.post('/appRole/add.do', params)
  },
  // 保存编辑角色权限
  saveEditRole(params) {
    return Http.post('/appRole/save.do', params)
  }
  // ----------------角色管理 end -----------------
}



// WEBPACK FOOTER //
// ./src/services/api/app.js